import React from 'react'
import { ReactComponent as SaasSvg} from '../../assets/svgs/SaaS.svg';

const SaasIcon = () => (
    <div>
        <SaasSvg/>
    </div>
)

export default SaasIcon